<script>
import {
  ArrowUpIcon,
  HeartIcon,
  EyeIcon,
  ShoppingCartIcon,
} from 'vue-feather-icons'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import Navbar from '@/view/front/components/navbar'
// import Switcher from "@/view/front/components/switcher";
import Footer from '@/view/front/components/footer'
import API from '@/core/api'
import IndexService from '@/MainServices/IndexService.js'
import Button from '../../pages/vue-bootstrap/Button.vue'
import Skeleton from '@/view/front/components/skeleton_home'

/**
 * Shop-product-detail component
 */
export default {
  data() {
    return {
      countval: 1,
      API: API.API_HOME,
      searchedCities: null,
      search: false,
      filterCitiesData: [],
      loading: true,
      searchUniByCity: '',
      show_load_more: true,
      cities: [],
      selected_cities: [],
    }
  },
  components: {
    Navbar,
    // Switcher,
    Footer,
    ArrowUpIcon,
    Skeleton,
  },
  methods: {
    filterCities(e) {
      this.filterCitiesData = this.cities.filter((el) => {
        return el.value == e
      })
      this.search = true
    },
    clearSearch() {
      this.searchedCities = null
      this.search = false
    },
    uniByCity(city) {
      this.$session.set('searchUniByCity', city)
      this.$router.push({ name: 'UniversitiesWithListings' })
    },
  },
  mounted() {
    IndexService.getCities()
      .then((res) => {
        res.data.map((el) => {
          this.cities.push({
            value: el.id,
            text: el.city,
          })
        })
        this.loading = false
      })
      .catch((e) => {})
  },
}
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="d-table w-100">
      <div class="main_top_uni_bg_hero_all_city">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12 text-center">
              <div class="page-next-level">
                <h4 class="uni-top-im-title">
                  <span class="text-success">All</span>
                  Cities
                </h4>
                <p class="uni-top-im-ptext">
                  Select your favourite
                  <span class="text-success">City</span>
                  and
                  <br />
                  apply in your dream university.
                </p>
                <div class="page-next"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg
          viewBox="0 0 2880 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <div class="container mt-15 px-40">
    <div class="row px-20">
      <div class="col-lg-12 p-0">
            <div class="text-center">
              <h3 class="r-font-s-38px font-weight-bold mb-8">Find universities by cities</h3>
              <div class="row p-0 m-0">
                <img src="/images/myuni/homepage/PNG/Faisalabad.png" role="button" alt="Faisalabad" class="col-3" @click="uniByCity('Faisalabad')">
                <img src="/images/myuni/homepage/PNG/Gujranwala.png" role="button" alt="Gujranwala" class="col-3" @click="uniByCity('Gujranwala')">
                <img src="/images/myuni/homepage/PNG/Islamabad.png" role="button" alt="Islamabad" class="col-3" @click="uniByCity('Islamabad')">
                <img src="/images/myuni/homepage/PNG/Karachi.png" role="button" alt="Karachi" class="col-3" @click="uniByCity('Karachi')">
                <img src="/images/myuni/homepage/PNG/Lahore.png" role="button" alt="Lahore" class="col-3" @click="uniByCity('Lahore')">
                <img src="/images/myuni/homepage/PNG/Peshawar.png" role="button" alt="Peshawar" class="col-3" @click="uniByCity('Peshawar')">
                <img src="/images/myuni/homepage/PNG/Quetta.png" role="button" alt="Quetta" class="col-3" @click="uniByCity('Quetta')">
                <img src="/images/myuni/homepage/PNG/Sialkot.png" role="button" alt="Sialkot" class="col-3" @click="uniByCity('Sialkot')">
              </div>
            </div>
          </div>
    </div>
  </div>
    <section class="section">
      <div class="container r_px_custom">
        <div class="justify-content-center">
          <div class="flex-show r_commbbo">
            <v-autocomplete
              :items="cities"
              v-model="searchedCities"
              label="Search by City name"
              @change="filterCities($event)"
              class="form-control mb-2 mr-sm-2 header-input"
            ></v-autocomplete>
            <button
              type="button"
              class="btn btn-success mb-2 header-uni-clear-btn font-weight-bold"
              @click="clearSearch"
            >
              Clear
            </button>
          </div>
        </div>
        <Skeleton v-if="loading" />

        <div class="row p-0 m-0" v-if="!search">
          <div
            class="col-2 pl-0 pb-0"
            v-for="(university, index) in cities"
            :key="index"
          >
            <h5 style="cursor: pointer;" @click="uniByCity(university.text)">{{ university.text }}</h5>
          </div>
        </div>
        <div class="row p-0 m-0" v-if="search">
          <div
            class="col-2 pl-0 pb-0"
            v-for="(university, index) in filterCitiesData"
            :key="index"
          >
            <h5 style="cursor: pointer;" @click="uniByCity(university.text)">{{ university.text }}</h5>
          </div>
        </div>
      </div>
    </section>

    <Footer />
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
  </div>
</template>

<style scoped>
.text-success {
  color: rgb(46, 202, 139) !important;
}
</style>
